import React, { useEffect, useState } from "react";
import Image from "next/image";
import { useTheme } from "next-themes";
import { useEffectiveTheme } from "@/utils/hooks";

interface PlutoLogoProps {
  className?: string;
}

const PlutoLogo = ({ className = "" }) => {
  const [imageSrc, setImageSrc] = useState("/pluto-logo.svg");
  const { theme, systemTheme } = useTheme();
  const { effectiveTheme, mounted } = useEffectiveTheme();

  useEffect(() => {
    if (!mounted) return;

    // Update logo based on the effective theme
    const logoSrc = "/pluto-logo.svg";
    // effectiveTheme === "dark" ? "/pluto-logo.svg" : "/pluto-logo-dark.svg";
    setImageSrc(logoSrc);
  }, [theme, systemTheme, mounted, effectiveTheme]);

  if (!mounted) return null;

  return (
    <div>
      <Image
        height={250}
        width={250}
        className={`h-8 w-auto rounded-lg ${className}`}
        src={imageSrc}
        alt="pluto-logo"
      />
    </div>
  );
};

export default PlutoLogo;
